import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'departments';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const departmentActions = { ...slice.actions, ...extraActions };
export const departmentReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        departments: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetDepartments`)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.departments = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.departments = action.payload;
            },
            [rejected]: (state, action) => {
                state.departments = { error: action.error };
            }
        };
    }
}
